import { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';
import { useNavigate } from 'react-router';

const backButtonStyle = (style): CSSProperties => ({
    color: Color.TEXT_LIGHT_BLUE,
    fontSize: Size.FontSize.Medium,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    wordBreak: 'keep-all',
    ...style,
});

export interface GoBackViewProps {
    textToShow?: string;
    style?: CSSProperties;
    dataId?: any;
    onButtonClick?: () => void;
}

export const GoBackView = ({ textToShow, style, dataId, onButtonClick }: GoBackViewProps) => {
    const text = textToShow ? textToShow : '< Go Back';
    const navigate = useNavigate();

    const handleGoBackClick = () => {
        if (onButtonClick) {
            onButtonClick();
        } else {
            navigate(-1);
        }
    };

    return (
        <div style={backButtonStyle(style)} onClick={handleGoBackClick} data-test-id={dataId}>
            <span>{text}</span>
        </div>
    );
};
